const routes = [
  {
    path: 'threejs2',
    name: 'threejs2',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs2.vue')
  },
  {
    path: 'threejs3',
    name: 'threejs3',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs3.vue')
  },
  {
    path: 'threejs4',
    name: 'threejs4',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs4.vue')
  },
  {
    path: 'threejs5',
    name: 'threejs5',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs5.vue')
  },
  {
    path: 'threejs6',
    name: 'threejs6',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs6.vue')
  },
  {
    path: 'threejs7',
    name: 'threejs7',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs7.vue')
  },
  {
    path: 'threejs8',
    name: 'threejs8',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs8.vue')
  },
  {
    path: 'threejs9',
    name: 'threejs9',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs9.vue')
  },
  {
    path: 'threejs10',
    name: 'threejs10',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs10.vue')
  },
  {
    path: 'threejs11',
    name: 'threejs11',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs11.vue')
  },
  {
    path: 'threejs12',
    name: 'threejs12',
    component: () => import(/* webpackChunkName: "threejs" */ '@/modules/threejs/threejs12.vue')
  },
];

export default routes;